<template>
  <form class="partner-editor" @submit.prevent="submit">
    <div class="partner-editor__grid">
      <div class="partner-editor__field">
        <label class="partner-editor__label" for="partner-rut">Rut</label>
        <input
          id="partner-rut"
          v-model.trim="form.rut"
          class="partner-editor__input"
          type="text"
          placeholder="12.345.678-9"
        >
      </div>

      <div class="partner-editor__field">
        <label class="partner-editor__label" for="partner-name">Nombre</label>
        <input
          id="partner-name"
          v-model.trim="form.name"
          class="partner-editor__input"
          type="text"
          placeholder="Nombre del socio"
        >
      </div>

      <div class="partner-editor__field">
        <label class="partner-editor__label" for="partner-participation">Participacion</label>
        <input
          id="partner-participation"
          v-model.number="form.participation_perc"
          class="partner-editor__input"
          type="number"
          min="0"
          max="100"
          step="0.01"
          placeholder="0"
        >
      </div>

      <div class="partner-editor__field">
        <label class="partner-editor__label" for="partner-birthday">Fecha nacimiento</label>
        <input
          id="partner-birthday"
          v-model="form.birthday"
          class="partner-editor__input"
          type="date"
        >
      </div>
    </div>

    <p v-if="error" class="partner-editor__error">{{ error }}</p>

    <footer class="partner-editor__actions">
      <button class="partner-editor__ghost" type="button" :disabled="saving" @click="$emit('cancel')">
        Cancelar
      </button>

      <button class="partner-editor__primary" type="submit" :disabled="saving">
        {{ saving ? 'Guardando...' : submitLabel }}
      </button>
    </footer>
  </form>
</template>

<script>
import companyPeopleService from '@/services/company/companyPeople.service'

const defaultForm = () => ({
  id: null,
  rut: '',
  name: '',
  participation_perc: 0,
  birthday: ''
})

export default {
  name: 'PartnerEditor',
  props: {
    value: {
      type: Object,
      default: null
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      form: defaultForm(),
      saving: false,
      error: ''
    }
  },
  computed: {
    submitLabel () {
      return this.form.id ? 'Guardar cambios' : 'Crear socio'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.form = {
          ...defaultForm(),
          ...(newValue || {})
        }
        if (this.form.birthday) {
          this.form.birthday = String(this.form.birthday).slice(0, 10)
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.form.rut) {
        this.error = 'El rut es obligatorio.'
        return false
      }
      if (!this.form.name) {
        this.error = 'El nombre es obligatorio.'
        return false
      }
      if (this.form.participation_perc === null || this.form.participation_perc === '' || Number.isNaN(Number(this.form.participation_perc))) {
        this.error = 'La participacion es obligatoria.'
        return false
      }
      this.error = ''
      return true
    },
    normalizePayload () {
      return {
        id: this.form.id,
        company_id: Number(this.companyId),
        rut: this.form.rut ? this.form.rut.replace(/\./g, '').trim() : '',
        name: this.form.name,
        participation_perc: Number(this.form.participation_perc),
        birthday: this.form.birthday || null
      }
    },
    async submit () {
      if (!this.validate()) return

      this.saving = true
      this.error = ''

      try {
        const payload = this.normalizePayload()
        const saved = this.form.id
          ? await companyPeopleService.updatePartner(payload)
          : await companyPeopleService.createPartner(payload)

        this.$emit('saved', saved)
      } catch (err) {
        this.error = err?.message || 'No fue posible guardar el socio.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.partner-editor {
  display: grid;
  gap: 1rem;
}

.partner-editor__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.partner-editor__field {
  display: grid;
  gap: 0.38rem;
}

.partner-editor__label {
  color: #4b3b2f;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.partner-editor__input {
  min-height: 2.9rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(102, 81, 57, 0.14);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  color: #241c16;
}

.partner-editor__error {
  margin: 0;
  color: #a24444;
  font-size: 0.9rem;
}

.partner-editor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
}

.partner-editor__ghost,
.partner-editor__primary {
  min-height: 2.65rem;
  padding: 0 0.95rem;
  border-radius: 999px;
}

.partner-editor__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
}

.partner-editor__primary {
  border: 0;
  background: linear-gradient(135deg, #251d16 0%, #4c3c2d 100%);
  color: #f7f0e5;
}

@media (max-width: 640px) {
  .partner-editor__grid {
    grid-template-columns: 1fr;
  }

  .partner-editor__actions {
    flex-direction: column;
  }
}
</style>

